
import {of as observableOf, Observable} from 'rxjs';
import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {tap} from 'rxjs/operators';

import {Requete, RequeteSummary, RequeteDetail, EventRequete} from '../../entities/requete/requete.model';
import {PieceComplementaire, PiecePostale} from '../../entities/piece-jointe';

@Injectable()
export class RequeteService {

    private _requeteMap = new Map<number, RequeteDetail>();

    private resourceUrl = '/api/requetes';

    constructor(private http: HttpClient) {
    }

    getAll(): Observable<Array<RequeteSummary>> {
        return this.http.get<Array<RequeteSummary>>(this.resourceUrl);
    }

    getById(id: number): Observable<any> {
        return this.http.get(`${this.resourceUrl}/${id}`);
    }

    changerTitre(id: number, nouveauTitre: string) {
        this.http.patch(`${this.resourceUrl}/${id}`, nouveauTitre).subscribe();
    }

    getRequeteSummary(id: number): Observable<RequeteSummary> {
        return this.http.get<RequeteSummary>(`${this.resourceUrl}/${id}/summary`);
    }

    getRequeteDetail(id: number): Observable<RequeteDetail> {
        /* if (!this._requeteMap.has(id)) {
            return this.getById(id).map(requete => {
                this._requeteMap.set(requete.id, requete);
                return requete;
            });
        } */

        if (!this._requeteMap.has(id)) {
            return this.getById(id).pipe(
                tap(requete => this._requeteMap.set(requete['id'], requete))
            );
        }
        return observableOf(this._requeteMap.get(id));
    }

    canAddPieces(requete: Requete): boolean {
        // Abstract the rule to allow adding pieces even if it is currently very simple.
        return requete.isSync;
    }

    addEvent(dossierId: number, event: EventRequete) {
        const dossier = this._requeteMap.get(dossierId);
        if (dossier) {
            dossier.events = [event, ...dossier.events];
        }
    }

    clear(): void {
        this._requeteMap.clear();
    }

    addDocument(requeteId: number, doc: any): Observable<any> {
        return this.http.post(`${this.resourceUrl}/${requeteId}/documents/add-documents`, doc);
    }


    readRequeteNumberToday(): Observable<any> {
        return this.http.get(this.resourceUrl + '?count&today');
    }

    notifyAccuseCourrier(dossierId: number, eventId: number, body: any): Observable<any> {
        return this.http.patch(`${this.resourceUrl}/${dossierId}/events/${eventId}/notification-accuse-courrier`, body);
    }

    generateInventairePreview(piecesComplementaires: PieceComplementaire[], piecesPostales: PiecePostale[], dossierId: number) {
         const event = {
            piecesComplementaires: piecesComplementaires.map(pc => pc.toDTO()),
            piecesPostales: piecesPostales.map(pp => pp.toDTO()),
        };

        return this.http
            .post(`/api/requetes/${dossierId}/inventaires/preview`, event, { responseType: 'blob' });
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/services/requete.service.ts